export const clamp = (v: number, lo: number, hi: number) => Math.min(hi, Math.max(lo, v));
export const snap = (v: number, g = 8) => Math.round(v / g) * g;
export const cx = (...c: (string | false | null | undefined)[]) => c.filter(Boolean).join(" ");

export function copyText(text: string): Promise<boolean> {
  // navigator.clipboard needs https or localhost; fall back for plain-http previews
  if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text).then(() => true, () => fallbackCopy(text));
  return Promise.resolve(fallbackCopy(text));
}

function fallbackCopy(text: string): boolean {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  ta.remove();
  return ok;
}

export function isTyping(e: { target: EventTarget | null }): boolean {
  const el = e.target as HTMLElement | null;
  if (!el) return false;
  const tag = el.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || el.isContentEditable;
}

export const isMac = typeof navigator !== "undefined" && /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
export const MOD = isMac ? "⌘" : "Ctrl";

export function domainOf(url: string): string {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
}

export function favicon(url: string): string {
  return `https://icons.duckduckgo.com/ip3/${domainOf(url)}.ico`;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? "?") + (parts[1]?.[0] ?? "")).toUpperCase();
}

const AGENT_COLORS: Record<string, string> = {
  claude: "#d97757",
  "claude code": "#d97757",
  chatgpt: "#10a37f",
  openai: "#10a37f",
  codex: "#7b8cff",
  cursor: "#e8e8ec",
  gemini: "#5b8def",
  grok: "#e8e8ec",
  windsurf: "#2fd3b5",
  n8n: "#ea4b71",
  zapier: "#ff6a2b",
  make: "#a85ef0",
  api: "#9aa3b5",
};

export function agentColor(name: string): string {
  const k = name.trim().toLowerCase();
  if (AGENT_COLORS[k]) return AGENT_COLORS[k];
  for (const [n, c] of Object.entries(AGENT_COLORS)) if (k.includes(n)) return c;
  let h = 0;
  for (const ch of k) h = (h * 31 + ch.charCodeAt(0)) % 360;
  return `hsl(${h} 70% 68%)`;
}
